/**
 * Cache helpers for list item resources.
 *
 * Note: invalidating `nextListItem` will refetch if the query is active, which can
 * advance the "next item" shown in the overlay. Use intentionally.
 */

/**
 * Invalidate active `nextListItem` queries so overlays refresh when list items change.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {{listId?: string|number}} [options]
 */
export const invalidateNextListItemQueries = (queryClient, options = {}) => {
	const {listId} = options;
	queryClient.invalidateQueries({
		predicate: query => {
			const key = query?.queryKey;
			if (!Array.isArray(key)) return false;
			if (key[0] !== 'listItem') return false;
			if (key[1] !== 'nextListItem') return false;
			if (!listId) return true;
			return `${key?.[2]?.listId ?? ''}` === `${listId}`;
		},
	});
};
